// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2k3_N","detailsBorder":"styles_detailsBorder__zEL7u"};